import React from "react";
import { InitialAppDataResponse } from "../../common/api/Models/types";
import { UseAxiosResult } from "axios-hooks";

export type AppDataStore =
	| (
			| {
					appData: undefined;
					isLoading: true;
			  }
			| {
					appData: InitialAppDataResponse;
					isLoading: false;
			  }
	  ) & {
			refreshData: undefined | UseAxiosResult<InitialAppDataResponse>[1];
			changeLocation: undefined | ((value: string, countryCode: string) => Promise<void>);
			changeTenantCountry: undefined | ((value: string) => Promise<void>);
	  };

export const InitialAppDataContext = React.createContext<AppDataStore>({
	appData: undefined,
	isLoading: true,
	refreshData: undefined,
	changeLocation: undefined,
	changeTenantCountry: undefined,
});
